import { CSSProperties } from 'react';
import { runwayColors, antGrey } from './globalStyles';

const styles = {
    containerStyle: {
        backgroundColor: antGrey.grey10,
        width: 80,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflowX: 'hidden',
        overflowY: 'auto',
        flexShrink: 0,
    } as CSSProperties,
    orgContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
    } as CSSProperties,
    logo: {
        height: 48,
        width: 48,
        borderRadius: 24,
        backgroundColor: antGrey.grey2,
    } as CSSProperties,
    orgsAndAvatarContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
    } as CSSProperties,
    userAvatar: {
        backgroundColor: runwayColors.primary,
    } as CSSProperties,
    list: {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
    } as CSSProperties,
};

export default styles;
